// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { authService, buildSignHeaders } from '@/pages/utils/tools';

export async function getKey(options?: { [key: string]: any }) {
  return request<{}>('/ltsoy_admin/v1/public/rsa/get-publicKey', {
    method: 'GET',
    ...(options || {}),
  });
}
export async function currentUser(options?: { [key: string]: any }) {
  return request<{}>(`/ltsoy_admin/v1/admin/user/detail/${options.userId}`, {
    method: 'GET',
    headers: {
      'template-admin-token': authService.getToken(),
    },
    ...(options || {}),
  });
}

export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/ltsoy_admin/v1/admin/admin-logout', {
    method: 'POST',
    headers: {
      'template-admin-token': authService.getToken(),
    },
    ...(options || {}),
  });
}

export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/ltsoy_admin/v1/admin/admin-login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
export async function sendEmailCode(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/ltsoy_admin/v1/password/forgotPassword-send-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
export async function checkCode(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/ltsoy_admin/v1/password/forgotPassword-email/checkCode', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
export async function resetPassword(body: API.ResetPassword, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/ltsoy_admin/v1/password/forgotPassword-email/ResetPassword', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}


export async function dashboard(body?: any, options?: { [key: string]: any }) {
  return request('/ltsoy_admin/v1/admin/dashboard/stat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'template-admin-token': authService.getToken(),
    },
    data: body,
    ...(options || {}),
  });
}
export async function userList(body?: any, options?: { [key: string]: any }) {
  return request('/ltsoy_admin/v1/admin/user/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'template-admin-token': authService.getToken(),
    },
    data: body,
    ...(options || {}),
  });
}
export async function activateUser(body?: any, options?: { [key: string]: any }) {
  return request('/ltsoy_admin/v1/admin/user/activate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'template-admin-token': authService.getToken(),
    },
    data: body,
    ...(options || {}),
  });
}
export async function suspendUser(body?: any, options?: { [key: string]: any }) {
  return request('/ltsoy_admin/v1/admin/user/suspend', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'template-admin-token': authService.getToken(),
    },
    data: body,
    ...(options || {}),
  });
}

export async function userLogin(body: {email:string,password:string}) {
  const signHeaders = await buildSignHeaders(body as Record<string, any>);
  return request<API.LoginResult>('/ltsoy_app/api/app/user/user-login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...signHeaders,
    },
    data: body
  });
}

export async function deleteUser(token:string) {
  const signHeaders = await buildSignHeaders();
  return request('/ltsoy_app/api/app/user/user-deactivated', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'template-app-token':token,
      ...signHeaders
    },
  });
}